export default "__VITE_ASSET__4570efdd__"